import { useSelector } from "react-redux";

function useStartHoursOfCompanyInSeconds({ show = true } = {}) {
	const startHour = useSelector(
		state => state.auth.selected_organization.setting.start_of_the_day
	);

	const startHoursInSeconds = (() => {
		try {
			if (!show) return 0;

			const [hours, seconds] = startHour.split(":").map(Number);

			return hours * 3600 + seconds;
		} catch (error) {
			return 0;
		}
	})();

	return startHoursInSeconds;
}

export default useStartHoursOfCompanyInSeconds;
